<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('batch_score_entry_note')"
                    :isColumns="false"
                    :isFilter="false"
            >
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('batch_score_entry_note')"
                          :isColumns="false"
                          :isFilter="false"
            >
            </HeaderMobile>
        </template>
        <b-col v-if="!Object.entries(students).length &&  !isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
            <div class="col-12">
                <div class="row border p-2 d-flex justify-content-center align-items-center">
                    <div class="d-flex flex-column align-items-center">
                        <i class="ri-information-line" style="font-size: 100px">
                        </i>
                        <p>
                            {{$t('no_students_enrolled_in_the_course')}}
                        </p>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col v-else-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
        </b-col>
        <div v-else>
            <div class="d-flex  flex-column  mb-3">
                <div class="d-flex justify-content-start overflow-auto">
                    <div>
                        <b-table
                            responsive
                            bordered
                            :items="sectionInformationTableItems"
                            :fields="fields"
                            class="border "
                        ></b-table>
                    </div>
                </div>
            </div>
            <div class=" d-flex justify-content-start overflow-auto" v-if="gradesItems.length > 0 && sectionGrades.instructor_can_edit_grade_scores">
                <div>
                    <b-table-simple responsive bordered class="border">
                        <b-tbody>
                            <b-tr v-for="(field, fieldIndex) in gradesFields" :key="fieldIndex">
                                <b-th class="header" v-if="field.key==='action' ">
                                    <span v-if="!isFinalizeExam">{{field.label}}</span>
                                </b-th>
                                <b-th class="header" v-else>{{ field.label }}</b-th>
                                <b-td
                                    v-for="(item, itemIndex) in gradesItems"
                                    :key="itemIndex"
                                    class="text-center"
                                >
                                    <div v-if="field.key === 'score'">
                                        <div v-if="item.edit">
                                            <ValidationProvider
                                                name="score"
                                                rules="required"
                                                v-slot="{ valid, errors }"
                                            >
                                                <b-input
                                                    v-model="item.score"
                                                    type="number"
                                                    max="100"
                                                    min="0"
                                                    @change="handleChangeInput(item, itemIndex)"
                                                    class="text-center"
                                                    style="max-width: 65px"
                                                ></b-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                            </ValidationProvider>
                                        </div>
                                        <div v-else class="text-center">{{ item.score }}</div>
                                    </div>
                                    <div v-else-if="field.key === 'action'">
                                        <div class="d-flex align-items-center justify-content-center">

                                            <div v-if="!item.edit && !['100','0'].includes(item.score) && !isFinalizeExam">
                                                <a
                                                    role="button"
                                                    class="editButton"
                                                    @click="onHandleEdit(item)"
                                                    v-b-tooltip.hover
                                                    :title="$t('edit')"
                                                >
                                                    <i class="ri-edit-box-line" style="font-size: 20px"></i>
                                                </a>
                                            </div>
                                            <div v-if="item.edit && item.isSave">
                                                <a
                                                    role="button"
                                                    class="deleteButton mr-2"
                                                    @click="onHandleSave({ item, index: itemIndex })"
                                                    v-b-tooltip.hover
                                                    :title="$t('save')"
                                                >
                                                    <i
                                                        class="ri-check-double-line"
                                                        style="font-size: 20px; color: blue"
                                                    ></i>
                                                </a>
                                            </div>
                                            <div v-if="item.edit">
                                                <a
                                                    role="button"
                                                    class="deleteButton"
                                                    @click="onHandleDelete(item, itemIndex)"
                                                    v-b-tooltip.hover
                                                    :title="$t('clear')"
                                                >
                                                    <i
                                                        class="ri-delete-bin-6-line"
                                                        style="font-size: 20px; color: red"
                                                    ></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ item[field.key] }}
                                    </div>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </div>

            <datatable-filter v-show="true" @filter="searchStudent" @filterClear="filterClear">
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                        <b-col sm="6" md="4" lg="3" xl="2" >
                            <b-form-group :label="$t('name')">
                                <b-form-input size="sm" v-model="filter.name"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col sm="6" md="4" lg="3" xl="2">
                            <b-form-group :label="$t('surname')">
                                <b-form-input size="sm" v-model="filter.surname" ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6" md="4" lg="3" xl="2">
                            <b-form-group :label="$t('student_number')">
                                <b-form-input size="sm" v-model="filter.student_number" ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </datatable-filter>
            <ValidationObserver ref="studentExamForm">
                <b-table-simple class="border w-100" small caption-top responsive hover bordered>
                    <thead>
                    <tr>
                        <th rowspan="2" class="text-center justify-center width-50">{{ $t('student_number') }}</th>
                        <th rowspan="2" class="text-center justify-center width-40">{{
                                $t('name') + ' ' + $t('surname')
                            }}
                        </th>
                        <th v-for="(exam,key) in examTypeArray" :key="'header-' + exam.id"
                            :colspan="exam.number_of_exams" class="border-bottom text-center">
                            <div class="d-flex flex-column align-items-center mb-2">
                                <span>{{ exam.name }}</span>
                            </div>
                        </th>
                        <th rowspan="2" class="text-center justify-center width-40">{{
                                $t('grade')
                            }}
                        </th>
                        <th rowspan="2" class="text-center justify-center width-40">{{
                                $t('instructor') + ' ' +$t('letter_grade')
                            }}
                        </th>
                    </tr>
                    <tr>

                        <template v-for="(exam,j) in examTypeArray">
                            <th v-for="(i, key) in exam.exams" :key="'checkbox-' + exam.id + '-' + i.rank" class="mobile-th">
                                <div class="d-flex align-items-center justify-content-center mb-2">
                                    <b-form-checkbox
                                        :disabled="i.has_finalize || (hasMakeUpExam && !i?.is_make_up)"
                                        @change="examStatusCheck(exam, i, key)"
                                        :id="'checkbox-' + exam.id + '-' + i.rank"
                                        v-model="exam.exams[key].is_active"
                                    >
                                        <span class="small-text">{{ i.date ? toLocaleDate(i.date) : null }}</span>
                                    </b-form-checkbox>

                                </div>
                                <div class="d-flex responsive-text">
                                    <span class="small-text text-nowrap">{{ $t('attended_the_exam') }}</span>
                                    <span class="small-text text-nowrap">{{ i.name }}</span>
                                </div>
                            </th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(student, index) in students[pagination.currentPage]" :key="student?.student_program_id + '-'+ index"
                        class="align-middle text-center">
                        <td>
                            {{ student?.student_number }}
                        </td>
                        <td class="text-center align-center">{{ student?.name }} {{ student?.surname }}</td>
                        <template v-for="(exam,i) in examTypeArray">
                            <td v-for="(examItem, key) in exam.exams" :key="'td-' + exam.id + '-' + examItem.rank"
                                class="width-30">
                                <div class="d-flex align-items-center justify-content-between" v-if="(!examItem.is_make_up || (examItem.is_make_up && selectedExams[exam.id][key + 1]?.[pagination.currentPage][index]?.make_up_exam_definition_ids))">
                                    <ValidationProvider
                                        :name="`attended-${exam.id}-${examItem.rank}-${index}`"
                                        rules="required"
                                        v-slot="{ valid, errors }"
                                    >
                                        <b-form-checkbox
                                            :disabled="!examItem.is_active || examItem.has_finalize ||  (examItem.is_make_up && !selectedExams[exam.id][key + 1]?.[pagination.currentPage][index]?.isStudentHasMakeUpExam)"
                                            v-if="selectedExams[exam.id] && selectedExams[exam.id][key + 1]?.[pagination.currentPage][index]"
                                            :id="'checkbox-' + exam.id + '-' + key"
                                            :value="1"
                                            :unchecked-value="0"
                                            @change="examStatusChange(selectedExams[exam.id][key + 1][pagination.currentPage][index])"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            v-model="selectedExams[exam.id][key + 1][pagination.currentPage][index].attended"
                                        >
                                        </b-form-checkbox>
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                    </ValidationProvider>
                                    <div class="width-100">
                                        <ValidationProvider
                                            :name="`score-${exam.id}-${examItem.rank}-${index}`"
                                            :rules="
                                                (!examItem.is_active || examItem.has_finalize || !selectedExams[exam.id][key + 1][pagination.currentPage][index].attended) ? '' : 'required'
                                                 "
                                            v-slot="{ valid, errors }"
                                        >
                                            <b-form-input
                                                v-if="selectedExams[exam.id] && selectedExams[exam.id][key + 1]?.[pagination.currentPage][index]"
                                                :placeholder="$t('grade_entry')"
                                                type="number"
                                                min="0"
                                                max="100"
                                                @input="restrictScore($event, exam.id, key + 1, index)"
                                                v-model="selectedExams[exam.id][key + 1][pagination.currentPage][index].score"
                                                :disabled="examItem.has_finalize || !examItem.is_active || !selectedExams[exam.id][key + 1][pagination.currentPage][index].attended
"                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >

                                            </b-form-input>

                                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>

                                        </ValidationProvider>
                                    </div>
                                </div>
                            </td>
                        </template>
                        <td class="width-30">
                            {{student?.score?student.score:'-'}}
                        </td>
                        <td class="width-30">
                            {{student?.instructors_letter_grade?student.instructors_letter_grade:'-'}}
                        </td>
                    </tr>
                    </tbody>
                    <b-tfoot>
                        <tr class="border">
                            <td colspan="2"></td>
                            <template v-for="(exam) in examTypeArray">
                                <td v-for="(i,key) in exam.exams" class="text-center" >
                                    <div class="d-flex btn-block flex-column align-items-center">
                                        <b-button
                                            v-show="shouldShowCancelButton(exam, i)"
                                            variant="success"
                                            class="mb-2 w-100 btn-responsive-text"
                                            @click="unpublishExams(exam,i.id)"
                                        >
                                            {{$t('finalize_grade_cancel')}}
                                        </b-button>
                                        <b-button
                                            v-show="i.is_active && !i.has_finalize"
                                            variant="success"
                                            class="mb-2 w-100"
                                            @click="saveExams(exam, i.rank)"
                                        >

                                            {{$t('save')}}
                                        </b-button>
                                        <b-button
                                            v-show="i.id && !i.has_finalize && i.is_finalize"
                                            variant="danger"
                                            class="w-100"
                                            @click="saveFinalize(i)"
                                        >
                                            {{ $t('finalize') }}
                                        </b-button>
                                    </div>
                                </td>
                            </template>

                        </tr>
                    </b-tfoot>
                </b-table-simple>
                <b-col class="w-100 d-flex flex-column flex-md-col justify-content-center align-items-center gap-3">
                    <div class="w-80 mb-3 w-md-auto" v-if="!hiddenPaginateSelect">
                        <b-form-select
                            v-model="selected"
                            @change="onPerPageChange(selected)"
                            :options="options"
                            class="form-select form-select-sm"
                        ></b-form-select>
                    </div>

                    <div class="w-100 d-md-flex justify-content-md-center align-items-center w-md-auto overflow-x-auto">
                        <ul class="pagination mb-0">
                            <li class="page-item">
                                <span class="page-link" @click="decrementPage">{{ $t('previous') }}</span>
                            </li>
                            <li
                                :class="pagination.currentPage === i ? 'page-item active' : 'page-item'"
                                v-for="i in pagination.totalPage"
                                :key="i"
                                @click="onSelectPage(i)"
                            >
                                <span class="page-link">{{ i }}</span>
                            </li>

                            <li class="page-item">
                                <span class="page-link" @click="incrementPage">{{ $t('next') }}</span>
                            </li>
                        </ul>
                    </div>
                </b-col>


            </ValidationObserver>
        </div>
    </app-layout>
</template>
<script>

import qs from "qs";
import ExamDefinationService from "@/services/ExamDefinationService";

export default {
    data() {
        return {
            fields: [
                {
                    key: 'staff',
                    label:this.$t('teaching_staff'),
                },
                {
                    key: 'course_name',
                    label: this.$t('course_name'),
                },
                {
                    key: 'section',
                    label: this.$t('section'),
                },
                {
                    key: 'student_count',
                    label: this.$t('total_student_count'),
                },
                {
                    key: 'evaluation_name',
                    label: this.$t('evaluation'),
                },


            ],
            sectionInformationTableItems: [],
            gradesItems:[],
            gradesFields:[
                {
                    key: 'grade',
                    label:this.$t('grade'),
                },
                {
                    key: 'score',
                    label: this.$t('score'),
                },
                {
                    key: 'action',
                    label: this.$t('action'),
                },
            ],
            selected:10,
            options: [
                { value: 5, text: 5 },
                { value: 10, text: 10 },
                { value: 15, text: 15 },
                { value: 20, text: 20 },

            ],
            royalStudents:[],
            royalSelectedExams:[],
            royalTotalPage: 0,
            royalGrades: [],
            hiddenPaginateSelect: false,
            isExamOptions:false,
            selectedExams: {},
            allExams: [],
            examTypeArray: [],
            hasMakeUpExam: false,
            examScore: [],
            students: [],
            paginateData:{},
            pagination:{
                currentPage:1,
                perPage:10,
                totalPage:0,
            },
            replacementStudent:[],
            isLoading:false,
            sectionGrades:null,
            filter:{
                name:null,
                surname:null,
                student_number:null
            },
            exams:[]
        };
    },
    metaInfo() {
        return {
            title: this.$t('batch_score_entry_note'),
        }
    },
    created() {
        this.getSectionInformation();
        this.getGradesInformation()
    },
    computed:{
        isFinalizeExam() {
            let examCount=0
            let examFinalizeCount=0
            if (this.allExams.length) {
                this.allExams.forEach((exam) => {
                    exam.exams.forEach(val => {
                        examCount++
                        if (val.is_finalized){
                            examFinalizeCount++
                        }
                    })
                })
            }
            return examCount ===examFinalizeCount
        },

    },

    methods: {
        shouldShowCancelButton(exam, currentExam) {
            if (!currentExam.has_finalize) return false;

            const hasAnyGlobalMakeUp = this.examTypeArray.some(type =>
                type.exams.some(e => e.is_make_up)
            );

            if (hasAnyGlobalMakeUp) {

                return currentExam.is_make_up;
            }

            return true;
        },
        paginateItems(items, perPage) {
            const paginated = {};
            for (let i = 0; i < items.length; i += perPage) {
                const page = Math.floor(i / perPage) + 1;
                paginated[page] = items.slice(i, i + perPage);
            }
            return paginated;
        },
        mapExamScores(examScoreData, students, examTypeArray, perPage) {
            let selectedExams = {};
            examTypeArray.forEach((value) => {
                selectedExams[value.id] = {};
                for (let i = 1; i <= value.number_of_exams; i++) {
                    let studentData = Object.values(students).flat().map((student) => {
                        return {
                            exam_type:value.exam_type,
                            student_program_id: student.student_program_id,
                            attended: 1,
                            score: null,
                            instructors_letter_grade: student.instructors_letter_grade,
                            make_up_exam_definition_ids: student?.make_up_exam_definition_ids,
                            calculate_score: student.score,
                        }

                    });
                    selectedExams[value.id][i] = studentData;
                }
            });
            Object.entries(examScoreData).forEach(([exam_definition_id, exam_rank]) => {
                if (selectedExams[exam_definition_id]) {
                    Object.entries(exam_rank).forEach(([rank, scoreItems]) => {
                        if (selectedExams[exam_definition_id][rank]) {
                            scoreItems.forEach((item) => {
                                const index = selectedExams[exam_definition_id][rank].findIndex(
                                    (entry) => entry.student_program_id === item.student_program_id
                                );
                                if (index !== -1) {
                                    const currentStudentData = selectedExams[exam_definition_id][rank][index];
                                    this.$set(selectedExams[exam_definition_id][rank], index, {
                                        student_program_id: item.student_program_id,
                                        attended: item.attended ? 1 : 0,
                                        score: item.score,
                                        make_up_exam_definition_ids: currentStudentData.make_up_exam_definition_ids,
                                        instructors_letter_grade: item.instructors_letter_grade,
                                        calculate_score: item.calculate_score,
                                    });
                                }
                            });
                        }
                    });
                }
            });

            Object.entries(selectedExams).forEach(([exam_definition_id, exam_rank]) => {
                Object.entries(exam_rank).forEach(([rank, data]) => {
                    selectedExams[exam_definition_id][rank] = this.paginateItems(data, perPage);
                });
            });
            return selectedExams;
        },
        async getExamOptions() {
            this.hasMakeUpExam = false;
            const examOptions = {};
            this.allExams.forEach((item) => {
                let number_of_exams=item.number_of_exams
                if (!examOptions[item.id]) {
                    if(item.exams.length > item.number_of_exams){
                      item.number_of_exams = item.exams.length
                    }
                    examOptions[item.id] = {
                        id: item.id,
                        name: item.exam_type_text,
                        exam_type:item.exam_type,
                        section_id: item.section_id,
                        effect_ratio: item.effect_ratio,
                        number_of_exams: item.number_of_exams,
                        exams: [],
                    };
                }
                for (let i = 0; i < item.number_of_exams; i++) {
                    const examData = item.exams && item.exams[i];
                    let name = `${item.exam_type_text}-${i}`
                    if(number_of_exams===1){
                      name = `${item.exam_type_text}`
                    }

                    if(examData?.is_make_up){
                      this.hasMakeUpExam = true
                      name = `${item.exam_type_text} - (MAKE-UP)`
                    }
                    examOptions[item.id].exams.push({
                      name: name,
                      id: examData ? examData.id : null,
                      rank: examData ? examData.rank - 1 : i,
                      is_active: false,
                      has_finalize: examData ? examData.is_finalized : false,
                      is_finalize: false,
                      date: examData ? examData.date : null,
                      is_make_up: examData ? examData?.is_make_up : false,
                    });
                }
                examOptions[item.id].exams.sort((a, b) => a.rank - b.rank);
            });
            this.examTypeArray = Object.values(examOptions);
        },
        async getGradesInformation(){
            try {
                const res = await  ExamDefinationService.sectionGrades(this.$route.params.sectionId)
                this.sectionGrades = res.data.data;
                this.royalGrades=res.data.data.grades
                if (!this.sectionInformationTableItems.length) {
                    this.sectionInformationTableItems.push({
                        staff: this.sectionGrades.instructor_name,
                        course_name: `${this.sectionGrades.course_name} (${this.sectionGrades.course_code})`,
                        section: this.sectionGrades.section,
                        student_count: this.sectionGrades.student_count,
                        evaluation_name:this.sectionGrades.evaluation_name
                    });
                }
                if(res.data.data.grades.length > 0) {
                    this.gradesItems=res.data.data.grades.map((entry) => {
                        return {
                            ...entry,
                            action:null,
                            edit:false,
                            isSave:false,
                        }
                    });
                }
            }catch (error) {
                this.showErrors(error);
            }
        },

        async getSectionInformation() {
            this.isLoading = true;
            const config = {
                params: {
                    filter: { section_id: this.$route.params.sectionId },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            try {
                const exams =await ExamDefinationService.getAll(config)
                const examScore =await   ExamDefinationService.getExamScore(config)
                const studentList =await  ExamDefinationService.getStudents(this.$route.params.sectionId)
                this.allExams = exams.data.data;
                this.students = studentList.data.data;
                this.replacementStudent = this.students;
                this.examScore = examScore.data.data;
                if (!this.isExamOptions) {
                    await this.getExamOptions();
                }
                this.paginationPage();
                await this.initializeAttendance(this.examScore.length > 0);
            } finally {
                this.isLoading = false;
                this.hiddenPaginateSelect=false
            }
        },
        async initializeAttendance(isExamScore) {
            if (!this.allExams || !Object.keys(this.students).length) return;

            const examScoreData = isExamScore ? await this.getExamScore() : {};
            this.selectedExams = this.mapExamScores(examScoreData, this.students, this.examTypeArray, this.pagination.perPage);
            this.royalSelectedExams = this.selectedExams;
        },
        async getExamScore() {
            const result = {};
            this.examScore.forEach((value) => {
                if (!result[value.exam_definition_id]) {
                    result[value.exam_definition_id] = {};
                }
                if (!result[value.exam_definition_id][value.exam_rank]) {
                    result[value.exam_definition_id][value.exam_rank] = [];
                }
                result[value.exam_definition_id][value.exam_rank].push({
                    student_program_id: value.student_program_id,
                    attended: value.attended,
                    score: value.score,
                });
            });
            return result;
        },
        paginationPage() {
            this.paginateData = this.paginateItems(this.replacementStudent, this.pagination.perPage);
            this.students = this.paginateData;
            this.royalStudents = this.students;
            this.pagination.totalPage = Object.keys(this.paginateData).length;
            this.royalTotalPage = this.pagination.totalPage;
        },
        examStatusCheck(exam, i, key) {
            let count = 0;
            let start = 0;
            const isMakeUpExam=exam.exams[key].is_make_up
            const examDefinitionId =exam.id

            if (isMakeUpExam){

                Object.entries(this.selectedExams[exam.id][key+1]).forEach(([page, students]) => {
                    const newStudents = []

                    newStudents.push(...students.map((student)=>{
                        const isStudentHasMakeUp = student.make_up_exam_definition_ids?.includes(examDefinitionId)
                        return {
                            ...student,
                            isStudentHasMakeUpExam:isStudentHasMakeUp,
                            attended: isStudentHasMakeUp?1:0
                        }
                    }))

                    this.selectedExams[exam.id][key+1][page]=newStudents

                })
            }

            this.selectedExams[exam.id][key+1][this.pagination.currentPage].forEach((item) => {
                if ((!item.attended && !item.score) || item.score) {
                    exam.exams[key].is_finalize = true
                } else if (isMakeUpExam){
                    exam.exams[key].is_finalize = true
                }
                else {
                    exam.exams[key].is_finalize = false
                }
            })


            //Not Girilirken Sınav sırası kontrol edilir. talep üzerine kaldırılmıstır
            // if (exam.exams.length > 1) {
            //     for (let i = 0; i < key; i++) {
            //         if (!exam.exams[key - 1]) {
            //             break
            //         }
            //
            //         this.selectedExams[exam.id][i + 1][this.pagination.currentPage].forEach((item) => {
            //             if ((!item.score && item.attended) ||  !exam.exams[key - 1].id) {
            //                 start += 1
            //                 exam.exams[key].is_active = false
            //             }
            //         })
            //     }
            //
            // }
            // if (start > 0) {
            //     this.$toast.error(this.$t('previous_exams_must_be_taken'))
            //     start = 0
            //     return
            // }
            this.examTypeArray.forEach(value => {
                value.exams.forEach(ex => {
                    if (ex.is_active) {
                        count++;
                    }
                });
            });
            if (count > 0) {
                this.examTypeArray.forEach(value => {
                    value.exams.forEach(ex => {
                        ex.is_active = false;
                    });

                });
                this.examTypeArray.forEach(value => {
                    if (value.id === exam.id) {
                        value.exams.forEach(ex => {
                            if (ex.rank === i.rank) {
                                ex.is_active = !ex.is_active;
                            }
                        });
                    }
                });
            } else {
                this.examTypeArray.forEach(value => {
                    if (value.id === exam.id) {
                        value.exams.forEach(ex => {
                            if (ex.rank === i.rank) {
                                ex.is_active = false
                            }
                        });
                    }
                });
            }
        },
        async calculateExamScore() {
            try {
                await ExamDefinationService.calculateExams(this.$route.params.sectionId);
            }  catch (error) {
                this.showErrors(error);
            }
        },
        async saveExams(exam, exam_rank) {
            if (!(await this.$refs.studentExamForm.validate())) return;

            const examRank = this.selectedExams[exam.id][exam_rank + 1] || this.selectedExams[exam.id][exam_rank];
            const studentGrades = Object.values(examRank).flat().filter((item) =>
                (item.attended && item.score || !item.attended && !item.score) && item.student_program_id
            );
            const formData = {
                exam_definition_id: exam.id,
                rank: exam_rank + 1,
                scores: studentGrades,
            };
            try {
                const res = await ExamDefinationService.examScoreSave(formData);
                this.$toast.success(this.$t(`api.${res.data.message}`));
                this.isExamOptions = true;
                await this.getSectionInformation();

            } catch (error) {
                this.$toast.error(error.data.message);
            } finally {
                const targetExam = exam.exams[exam_rank] || exam.exams[exam_rank - 1];
                if (targetExam) targetExam.is_active = true;
            }
        },
        async unpublishExams(exam,exam_id) {
            if (!(await this.$refs.studentExamForm.validate())) return;

            try {
                const res = await ExamDefinationService.unpublishExam(exam_id);
                this.$toast.success(this.$t(`api.${res.data.message}`));
                this.isExamOptions = false;
                await this.calculateExamScore();
                this.isLoading = true;
                await new Promise((resolve) => setTimeout(resolve, 300));
                await this.getSectionInformation();

            } catch (error) {
                this.$toast.error(error.data.message);
            }
        },
        examStatusChange(examStatus) {
            if (!examStatus.attended) {
                examStatus.score = null
            }
        },
        async saveFinalize(i) {
            if (!i.id) return
            try {
                const res = await ExamDefinationService.saveExamPublish(i.id);
                this.$toast.success(this.$t("api." + res.data.message));
                this.isExamOptions=false
                await this.calculateExamScore();
                this.isLoading = true;
                await new Promise((resolve) => setTimeout(resolve, 300));
                await this.getSectionInformation();
                await this.getGradesInformation();
            } catch (error) {
                this.$toast.error(error.data.message);
            }
        },
        turkishStringToUpperCase(string) {
            const letters = { i: 'İ', ş: 'Ş', ğ: 'Ğ', ü: 'Ü', ö: 'Ö', ç: 'Ç', ı: 'I' };
            return string.replace(/(([iışğüçö]))/g, (letter) => letters[letter]).toUpperCase();
        },
        async searchStudent() {
            const examScoreData = await this.getExamScore();
            const filterKeys = Object.keys(this.filter).filter((key) => this.filter[key]);

            if (!filterKeys.length) {
                this.resetToOriginalData();
                return;
            }
            const filteredArray = this.replacementStudent.filter((student) =>
                filterKeys.every((key) => {
                    const filterValue = this.turkishStringToUpperCase(this.filter[key]).trim();
                    const studentNumber = this.turkishStringToUpperCase(student.student_number || '').trim();
                    const studentName = this.turkishStringToUpperCase(student.name || '').trim();
                    const studentSurname = this.turkishStringToUpperCase(student.surname || '').trim();
                    return studentNumber.includes(filterValue) || studentName.includes(filterValue) || studentSurname.includes(filterValue);
                })
            );
            if (!filteredArray.length) {
                this.resetToOriginalData();
                return;
            }
            const paginateData = this.paginateItems(filteredArray, this.pagination.perPage);
            this.students = paginateData;
            this.pagination.totalPage = Object.keys(paginateData).length;
            this.selectedExams = this.mapExamScores(examScoreData, paginateData, this.examTypeArray, this.pagination.perPage);
            this.hiddenPaginateSelect = true;
        },
        resetToOriginalData() {
            this.students = this.royalStudents;
            this.selectedExams = this.royalSelectedExams;
            this.pagination.totalPage = this.royalTotalPage;
            this.hiddenPaginateSelect = false;
        },
        filterClear() {
            this.filter = {};
            this.resetToOriginalData();
        },
        restrictScore(event, examId, rank, index) {
            let value = event;
            if (isNaN(value) || value < 0) value = 0;
            else if (value > 100) value = 100;

            this.$set(this.selectedExams[examId][rank][this.pagination.currentPage], index, {
                ...this.selectedExams[examId][rank][this.pagination.currentPage][index],
                score: value,
            });
        },
        decrementPage() {
            if (this.pagination.currentPage > 1) this.pagination.currentPage -= 1;
        },
        incrementPage() {
            if (this.pagination.totalPage > this.pagination.currentPage) this.pagination.currentPage += 1;
        },
        onSelectPage(page) {
            this.pagination.currentPage = page;
        },
        onPerPageChange(page) {
            this.pagination.perPage = page;
            this.pagination.currentPage = 1;
            this.getSectionInformation();
        },
        onHandleEdit(item){
            item.edit=true
        },
        onHandleDelete(item,index){
            if (item.score!==this.royalGrades[index].score){
                item.isSave=false
            }
            item.score=this.royalGrades[index].score
            item.edit=false;

        },
        handleChangeInput(item,index){
            if (item.score!==this.royalGrades[index].score){
                item.isSave=true
            }
        },
        async onHandleSave(row,index) {
            try {
                const config ={
                    grades:{
                        ...this.gradesItems,
                    }
                }
                const res = await ExamDefinationService.updateSectionGrade(this.$route.params.sectionId,config);
                this.$toast.success(this.$t('api.' + res.data.message));
                await this.getGradesInformation()

            }catch (error) {
                this.showErrors(error)
            }



        }
    },

};
</script>
<style scoped>
.small-text {
    font-size: 0.7rem;
    line-height: 1;
}

.text-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mobile-th {
    padding: 0.2rem !important;
    min-width: 20px !important;
    max-width: 20px !important;
}

.responsive-text {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 !important;
    margin: 0 !important;
    gap: 2px;
}

.btn-responsive-text{
    font-size: 7px;
    font-weight: bold;
    line-height: 1.5;
}

@media (min-width: 1300px) {
    .btn-responsive-text {
        font-size: 10px;
        font-weight: bold;
    }

}


@media (max-width: 768px) {
    .responsive-text {
        flex-direction: column;
        align-items: flex-start;
        gap: 1px;
    }

    .mobile-th {
        min-width: 50px !important;
        max-width: 70px !important;
    }

    .small-text {
        font-size: 0.6rem;
    }
}

@media (max-width: 480px) {
    .responsive-text {
        gap: 0;
    }
    .mobile-th {
        min-width: 40px !important;
        max-width: 60px !important;
    }
}
.editButton:hover{
    transform: scale(1.5);
    transition: transform 0.2s ease-in-out;

}
.deleteButton{
    transform: scale(1.5);
    transition: transform 0.2s ease-in-out;
}

</style>
